var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#23BEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1819 7.57631L13.0039 5.65706C13.788 6.59325 14.2169 7.77599 14.2149 8.99719C14.2149 11.8755 11.8806 14.2093 9 14.2093C8.12115 14.2104 7.25641 13.9884 6.48675 13.5641L11.1206 11.1757L11.8755 10.7865L11.1763 10.3033L10.6768 9.95794L12.1337 9.21431L12.8582 8.84419L12.2091 8.35369L11.1819 7.57631ZM6.81806 10.6892L5.11931 12.4779C4.25892 11.5229 3.78349 10.2826 3.78506 8.99719C3.78506 6.11831 6.11944 3.7845 9 3.7845C9.97582 3.78318 10.9322 4.05689 11.7596 4.57425L6.87938 7.08975L6.1245 7.47956L6.82369 7.96219L7.32319 8.30756L5.86631 9.05175L5.14181 9.42131L5.79094 9.91237L6.81806 10.6892ZM4.8015 12.8138L4.44994 13.1839C3.39615 12.0445 2.81135 10.5492 2.8125 8.99719C2.8125 5.58675 5.58844 2.8125 9 2.8125C10.4023 2.8125 11.6978 3.28163 12.7367 4.07081L12.2293 4.33238C11.2814 3.67349 10.1544 3.32091 9 3.32213C5.86969 3.32213 3.32269 5.868 3.32269 8.99719C3.32269 10.4653 3.88294 11.8046 4.80206 12.8132L4.8015 12.8138ZM13.3223 5.32125L13.6755 4.95C14.6519 6.07209 15.189 7.50976 15.1875 8.99719C15.1875 12.4071 12.4116 15.1813 9 15.1813C7.74282 15.1828 6.51534 14.7992 5.48269 14.0822L6.00244 13.8139C6.90129 14.3755 7.9401 14.6728 9 14.6717C12.1303 14.6717 14.6773 12.1258 14.6773 8.99719C14.6773 7.59656 14.1671 6.31294 13.3223 5.32181V5.32125ZM6.09863 9.50625L8.31544 8.37394L7.11338 7.54369L13.7678 4.11356L10.4192 7.63931L11.9014 8.76038L9.68456 9.89269L10.8866 10.7229L4.23225 14.1531L7.58081 10.6273L6.09863 9.50625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtn);
export default __webpack_public_path__ + "static/media/etn.5c621f3f99948318e3fbed9fd80e733b.svg";
export { ForwardRef as ReactComponent };